<template>
  <div v-if="wizardSteps" class="auto-implantacao">
    <WizardSteps
      :wizard-steps="wizardSteps"
      @open-store="openStore"
      @navigate="navigate"
    />
    <WizardActions
      class="mt-5"
      v-if="!isPublished"
      :available-steps="availableSteps"
      :can-publish="canPublish"
      :last-step="lastStep"
      @navigate="navigate"
    />
    <FormButton
      v-if="!isPublished"
      :disabled="!canPublish || isLoading"
      @click="publish"
      type="orange"
      class="mt-5 white--text font-weight-bold"
      full
    >
      Publicar
    </FormButton>
  </div>
</template>

<script>
import FormButton from "@/components/form/FormButton";
import WizardSteps from "./WizardSteps.vue";
import WizardActions from "./WizardActions.vue";
import { mapGetters } from "vuex";
import {
  ADMIN_GET_PASSOS_IMPLANTACAO,
  ADMIN_LOAD_CONFIG,
  ADMIN_UPDATE_PUBLISH
} from "@/store/actions/admin";
import { DADOS_EMPRESA_GET } from "@/store/actions/dadosEmpresa";

import * as _ from "lodash";

export default {
  name: "AutoImplantacao",
  components: { WizardSteps, WizardActions, FormButton },
  data() {
    return {
      isLoading: false,
      empresa: {},
      wizardSteps: null,
      lastStep: null,
      dominio: null
    };
  },
  computed: {
    ...mapGetters(["getFornecedor"]),
    availableSteps() {
      return this.wizardSteps.filter(w => !w.query_resolucao);
    },
    canPublish() {
      return (
        this.availableSteps.length === 0 && this.empresa.pagamento_configurado
      );
    },
    isPublished() {
      return this.getFornecedor.publicado;
    }
  },
  created() {
    this.getEmpresas();
    this.getPassosImplantacao();
  },
  methods: {
    getEmpresas() {
      this.isLoading = true;
      this.$store
        .dispatch(DADOS_EMPRESA_GET)
        .then(data => {
          this.empresa = data;
          this.isLoading = false;
        })
        .catch(() => {
          this.$vueOnToast.pop("error", "Falha ao buscar empresa");
          this.isLoading = false;
        });
    },
    getPassosImplantacao() {
      this.isLoading = true;
      this.$store
        .dispatch(ADMIN_GET_PASSOS_IMPLANTACAO, {
          execute: `${true}`,
          step: ""
        })
        .then(data => {
          this.isLoading = false;
          this.wizardSteps = data || [];
          this.lastStep = data && data.length ? data[data.length - 1] : null;
          this.getConfig();
        })
        .catch(err => {
          const erro =
            err.response.data.Mensagem ||
            err.response.data ||
            "Falha ao buscar os passos de implantação";
          this.$vueOnToast.pop("error", erro);
          this.isLoading = false;
        });
    },
    getConfig() {
      this.isLoading = true;
      this.$store
        .dispatch(ADMIN_LOAD_CONFIG, {
          dominio: "dominio",
          assunto: "ecommerce"
        })
        .then(data => {
          this.isLoading = false;
          this.dominio = (data || [])[0];
        });
    },
    openStore() {
      const dominio = _.get(this.dominio, "config.dominio") || "";
      if (!dominio) {
        this.$vueOnToast.pop(
          "warning",
          "Domínio da loja ainda não foi cadastrado"
        );
        return;
      }
      window.open(`//${dominio}`);
    },
    navigate(step) {
      if (!step || !step.paginas) {
        this.$vueOnToast.pop(
          "error",
          "Falha ao tentar acessar a página dessa etapa"
        );
        return;
      }
      window.open(step.paginas.posterior, "_self");
    },
    publish() {
      this.isLoading = true;
      this.$store
        .dispatch(ADMIN_UPDATE_PUBLISH, { status: `${true}` })
        .then(() => {
          this.isLoading = false;
          this.$vueOnToast.pop("success", "Publicação realizada com sucesso");
          setTimeout(() => location.reload(), 1500);
        })
        .catch(() => {
          this.isLoading = false;
          this.$vueOnToast.pop("error", "Falha ao publicar fornecedor");
        });
    }
  }
};
</script>

<style scoped>
.active-button {
  background-color: #f59612;
  color: white;
}
</style>
